/** Cross-fades the hero photos of sections/kingstar-hero.liquid. */
class KingStarHero extends HTMLElement {
  connectedCallback() {
    const images = [...this.querySelectorAll('.kingstar-hero__image')];
    if (images.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    images.forEach((image) => image.setAttribute('loading', 'eager'));
    let current = 0;
    this.timer = setInterval(() => {
      images[current].dataset.active = 'false';
      current = (current + 1) % images.length;
      images[current].dataset.active = 'true';
    }, Number(this.dataset.interval) || 8000);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }
}

if (!customElements.get('kingstar-hero')) customElements.define('kingstar-hero', KingStarHero);
